const additionalCoverageBenefits = ['0053', '0054'];
export default additionalCoverageBenefits;
